"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.match = exports.isSomeNot = exports.isOr = exports.isNot = exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _styledComponents = require("styled-components");
/**
 * IMPORTANT: This is a direct copy of the styled-is npm package source code.
 *
 * The styled-is package is unmaintained and requires React v16 peer dependency,
 * forcing --legacy-peer-deps on npm install. We copied the source here to remove
 * this dependency issue.
 *
 * Avoid extending or modifying this file if possible.
 *
 * See https://honeybook.atlassian.net/browse/HBUI-53 for more details.
 */

// This Source Code Form is subject to the terms of the Mozilla Public
// License, v. 2.0. If a copy of the MPL was not distributed with this
// file, You can obtain one at http://mozilla.org/MPL/2.0/.

var styledIf = function styledIf(method, condition) {
  return function () {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }
    return function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return function (props) {
        return (method === 'match' ? props[names[0]] === names[1] : names[method](function (name) {
          return Boolean(props[name]) === condition;
        })) && _styledComponents.css.apply(void 0, (0, _toConsumableArray2["default"])(handleFunctions(args, props)));
      };
    };
  };
};
var handleFunctions = function handleFunctions(args, props) {
  var css = '';
  for (var i = 1; i < args.length; i++) {
    if (typeof args[i] === 'function') {
      var output = args[i](props);
      if (typeof output === 'string' && output.includes(':')) {
        css += output;
      }
    }
  }
  if (css) {
    var newArgs = args.slice(0);
    var argCss = args[0].slice(1);
    argCss.unshift(css + newArgs[0][0]);
    newArgs[0] = argCss;
    return newArgs;
  }
  return args;
};
var is = styledIf('every', true);
var isNot = exports.isNot = styledIf('every', false);
var isOr = exports.isOr = styledIf('some', true);
var isSomeNot = exports.isSomeNot = styledIf('some', false);
var match = exports.match = styledIf('match');
var _default = exports["default"] = is;
//# sourceMappingURL=index.js.map